import React from "react";

import { useTranslation } from "react-i18next";
import { Image } from "semantic-ui-react";
import { AppPrimaryButton } from "../../../UI/CustomButtons";
import useTheme from "../../../../hooks/useTheme";
import { AppColumn } from "../../../UI/Layouts";
import { SizedBox } from "../../../UI/Sizes";
import AppText from "../../../UI/Texts/AppTexts";
import { useNavigate } from "react-router-dom";
import { LANDING_PAGE_PATH } from "../../../../utils/Constants/Paths";

export function JobPageNotFound() {
  const theme = useTheme();
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <AppColumn
      mainAxisAlignment={"center"}
      crossAxisAlignment={"center"}
      style={{
        height: "80%",
      }}
    >
      <Image
        alt="Page not found"
        src="/assets/stm_404.png"
        size="small"
        loading="lazy"
      />

      <SizedBox height={theme.spacing.contentPadding} />

      <AppText.SubHeading
        center
        use={"h1"}
        margins={{ marginBottom: "0px", marginTop: "0px" }}
        fontWeight={600}
      >
        {t("job_not_found_title")}
      </AppText.SubHeading>
      <SizedBox height={theme.spacing.elementPadding} />

      <AppText.BodyText center>{t("job_not_found")}</AppText.BodyText>
      <SizedBox height={theme.spacing.contentPadding} />

      <AppColumn crossAxisAlignment={"center"}>
        <AppPrimaryButton
          size="big"
          href={LANDING_PAGE_PATH}
          onClick={() => {
            navigate(LANDING_PAGE_PATH);
          }}
          style={{
            borderRadius: theme.radius.small,
          }}
        >
          {t("home")}
        </AppPrimaryButton>
      </AppColumn>
    </AppColumn>
  );
}
